module.exports = __webpack_public_path__ + "72577dafbe95a5bf8fc301c45a85cbb9.jpg";